/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardRegistrantEntry
 */
export interface LeaderboardRegistrantEntry {
    /**
     * Present only on the caller's own row — every other id is redacted out.
     * @type {string}
     * @memberof LeaderboardRegistrantEntry
     */
    userId?: string;
    /**
     * Resolved server-side so the board can tag the viewer without holding ids.
     * @type {boolean}
     * @memberof LeaderboardRegistrantEntry
     */
    isMe: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardRegistrantEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardRegistrantEntry
     */
    avatarUrl?: string;
    /**
     * Tier id — drives the shared avatar's tier ring, same as a ranked row.
     * @type {string}
     * @memberof LeaderboardRegistrantEntry
     */
    subscriptionTier?: string;
}

/**
 * Check if a given object implements the LeaderboardRegistrantEntry interface.
 */
export function instanceOfLeaderboardRegistrantEntry(value: object): value is LeaderboardRegistrantEntry {
    if (!('isMe' in value) || value['isMe'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function LeaderboardRegistrantEntryFromJSON(json: any): LeaderboardRegistrantEntry {
    return LeaderboardRegistrantEntryFromJSONTyped(json, false);
}

export function LeaderboardRegistrantEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardRegistrantEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isMe': json['isMe'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'subscriptionTier': json['subscriptionTier'] == null ? undefined : json['subscriptionTier'],
    };
}

export function LeaderboardRegistrantEntryToJSON(json: any): LeaderboardRegistrantEntry {
    return LeaderboardRegistrantEntryToJSONTyped(json, false);
}

export function LeaderboardRegistrantEntryToJSONTyped(value?: LeaderboardRegistrantEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'isMe': value['isMe'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'subscriptionTier': value['subscriptionTier'],
    };
}

